
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        whiskey:
          "border-transparent bg-whiskey-amber text-black hover:bg-whiskey-amber/80",
        // WCAG 2.1 AA Compliant badge variants (4.5:1+ contrast ratio)
        "blue-compliant":
          "border-transparent bg-blue-100 text-blue-900 hover:bg-blue-200",
        "purple-compliant":
          "border-transparent bg-purple-100 text-purple-900 hover:bg-purple-200",
        "yellow-compliant":
          "border-transparent bg-yellow-100 text-yellow-900 hover:bg-yellow-200",
        "green-compliant":
          "border-transparent bg-green-100 text-green-900 hover:bg-green-200",
        "red-compliant":
          "border-transparent bg-red-100 text-red-900 hover:bg-red-200",
        "whiskey-compliant":
          "border-transparent bg-whiskey-amber text-whiskey-dark hover:bg-whiskey-amber/90",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
